import React from "react"
import { ShapeA, ShapeB, ShapeC, ShapeD } from "../Shapes"

const MAX_TILES_PER_ROW = 4

const getShapeByPosition = (
  position: number,
  rowNumber: number,
  rowType: "even" | "odd"
) => {
  const firstRowPosition = MAX_TILES_PER_ROW * rowNumber - 3
  const secondRowPosition = firstRowPosition + 1
  const thirdRowPosition = secondRowPosition + 1
  const lastRowPosition = MAX_TILES_PER_ROW * rowNumber

  if (rowType === "even") {
    switch (position) {
      case firstRowPosition:
        return <ShapeC />
      case secondRowPosition:
        return <ShapeD />
      case thirdRowPosition:
        return <ShapeA />
      case lastRowPosition:
        return <ShapeB />
      default:
        return <ShapeC />
    }
  } else {
    // rowType === "odd"
    switch (position) {
      case firstRowPosition:
        return <ShapeA />
      case secondRowPosition:
        return <ShapeB />
      case thirdRowPosition:
        return <ShapeC />
      case lastRowPosition:
        return <ShapeD />
      default:
        return <ShapeA />
    }
  }
}

export const useShapeByRowPosition = (index: number) => {
  const position = index + 1

  const isLastTileInRowOfFour = position % 4 === 0

  const positionInRow = Math.floor(position / MAX_TILES_PER_ROW)

  // The last tile in a row will be the a full integer on the higher end of its interval
  // Example: Tiles 1-4 (first row)
  // 1/4 (position/MAX_TILES_PER_ROW) = 0.25 ~ row 0
  // 2/4 (position/MAX_TILES_PER_ROW) = 0.5 ~ row 0
  // 3/4 (position/MAX_TILES_PER_ROW) = 0.75 ~ row 0
  // 4/4 (position/MAX_TILES_PER_ROW) = 1 -> subtract 1 to be in row 0

  // Example 2: Tiles 5-8 (second row)
  // 5/4 (position/MAX_TILES_PER_ROW) = 1.25 ~ row 1
  // 6/4 (position/MAX_TILES_PER_ROW) = 1.5 ~ row 1
  // 7/4 (position/MAX_TILES_PER_ROW) = 1.75 ~ row 1
  // 8/4 (position/MAX_TILES_PER_ROW) = 2 -> subtract 1 to be in row 1
  const rowNumber = isLastTileInRowOfFour ? positionInRow - 1 : positionInRow

  // The first row will result to 0, that's why we add 1.
  // The row number MUST start from 1 instead of 0.
  const formattedRowNumber = rowNumber + 1

  const isEvenRow = formattedRowNumber % 2 === 0

  let shape: JSX.Element

  switch (isEvenRow) {
    case false:
      shape = getShapeByPosition(position, formattedRowNumber, "odd")
      return {
        shape,
      }
    default:
      shape = getShapeByPosition(position, formattedRowNumber, "even")
      return {
        shape,
      }
  }
}
